var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-calendar","titulo":"CONTRATAÇÕES VENCENDO ENTRE 14 E 7 DIAS","qtd":_vm.qtd,"loading":_vm.loading,"color":"#ff4040"}})
}
var staticRenderFns = []

export { render, staticRenderFns }